import styled from 'styled-components';

import { theme } from '../../../../common/ui/theme';

export const OfferActionsGrid = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    row-gap: ${theme.space[8]};
    border-left: 1px solid ${theme.colors.border.muted};
    padding: ${theme.space[16]};
`;
